import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import {
  GuidedHouseholdReviewOutroHowWeBringThisToLifeSection, sectionMetaOverrideSet,
} from 'Views/Page/Content/Templates/guidedHouseholdReviewOutroHowWeBringThisToLifeTemplate/section';

export const GuidedHouseholdReviewOutroHowWeBringThisToLifeLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'}>
      <FDStack direction={'column'} alignItems={'center'}>
        {resource.attr('subtitle').map(text => <FDBodyText size={'lg'} value={text} />)}
      </FDStack>
      <FDStack direction={'row'} spacing={4}>
        <MetaCollectionRenderer collection={resource.attr('sections')} layout={GuidedHouseholdReviewOutroHowWeBringThisToLifeSection} metaOverrideSet={sectionMetaOverrideSet} />
      </FDStack>
    </FDStack>
  );
};
